import { render, staticRenderFns } from "./TruckListItem.vue?vue&type=template&id=5ea8f9cb&scoped=true"
import script from "./TruckListItem.vue?vue&type=script&lang=js"
export * from "./TruckListItem.vue?vue&type=script&lang=js"
import style0 from "./TruckListItem.vue?vue&type=style&index=0&id=5ea8f9cb&prod&lang=css"
import style1 from "./TruckListItem.vue?vue&type=style&index=1&id=5ea8f9cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8f9cb",
  null
  
)

export default component.exports